import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Twitter, Instagram, Mail, MapPin } from 'lucide-react';

export default function Footer() {
  return (
    <footer className="bg-black text-white/80 mt-24">
      <div className="h-1 brand-gradient" />
      <div className="max-w-7xl mx-auto px-5 md:px-8 py-14 grid md:grid-cols-4 gap-10">
        <div>
          <Link to="/" className="inline-block bg-white rounded-md p-4">
            <img
              src="https://customer-assets-lxgj4vgw.emergentagent.net/job_strength-success-hub/artifacts/4iwss1im_ST-fitness-logo-colour.webp"
              alt="Sam Turner Health & Fitness"
              className="h-24 w-auto object-contain"
            />
          </Link>
          <div className="text-[10px] tracking-[0.28em] text-white/70 uppercase mt-3">Irlam · Manchester</div>
          <p className="mt-5 text-sm leading-relaxed text-white/60">Give your best, get results. Manchester based personal training, group fitness and online coaching, built around you.</p>
          <div className="flex items-center gap-3 mt-5">
            {[Facebook, Twitter, Instagram].map((Icon, i) => (
              <a key={i} href="#" className="w-9 h-9 grid place-items-center rounded-full border border-white/15 hover:border-brand hover:text-brand transition-colors">
                <Icon className="w-4 h-4" />
              </a>
            ))}
          </div>
        </div>

        <div>
          <h4 className="font-display text-lg tracking-wider text-white mb-4">Explore</h4>
          <ul className="space-y-2 text-sm">
            {[['About', '/about'], ['Transform', '/transform'], ['Timetable', '/timetable'], ['Location', '/location'], ['Contact', '/contact']].map(([l, to]) => (
              <li key={to}><Link to={to} className="hover:text-brand transition-colors">{l}</Link></li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="font-display text-lg tracking-wider text-white mb-4">Programmes</h4>
          <ul className="space-y-2 text-sm">
            <li>1-2-1 Personal Training</li>
            <li>Group Fitness Classes</li>
            <li>Online Coaching</li>
            <li>Nutrition Planning</li>
            <li>Mum & Baby Sessions</li>
          </ul>
        </div>

        <div>
          <h4 className="font-display text-lg tracking-wider text-white mb-4">Get in touch</h4>
          <ul className="space-y-3 text-sm">
            <li className="flex items-start gap-2.5"><MapPin className="w-4 h-4 mt-0.5 text-brand flex-shrink-0" /> <span>ST Fitness · inside Lycan Strength<br />Unit 2, Oasis Business Centre<br />Irlam, Manchester M44 5BL</span></li>
            <li className="flex items-center gap-2.5"><Mail className="w-4 h-4 text-brand" /> sam.turner@st-fitness-coach.co.uk</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/5">
        <div className="max-w-7xl mx-auto px-5 md:px-8 py-5 flex flex-col md:flex-row items-center justify-between text-xs text-white/50">
          <div>© {new Date().getFullYear()} ST Fitness · Irlam · Manchester. All rights reserved.</div>
          <div className="tracking-widest uppercase">Give Your Best, Get Results</div>
        </div>
      </div>
    </footer>
  );
}
